import React from "react";
import { Grid, Card, CardContent, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    overflow: 'hidden',
    boxShadow: 'none !important',
    '&:hover $image': {
      transform: 'scale(1.05)',
    },
  },
  image: {
    width: '100%',
    borderRadius: '5%',
    transition: 'transform 0.3s ease-in-out',
  },
}));

const MyCard = ({ title, content }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent sx={{padding:'0'}}>
        <Grid container direction='column' spacing={1.5}>
          <Grid item md={12} sx={{border:'0.5px solig grey', borderRadius: '5%', overflow:'hidden'}}>
            <img
              src="https://reno.b-cdn.net/wp-content/uploads/2023/08/slider3-525x328.jpg"
              alt="property_image"
              className={classes.image}
            />
          </Grid>
          <Grid item md={12} mt={1.5}>
            <Grid container spacing={0.5}>
              <Grid item md={12}>
                <Typography variant="body1" fontWeight='bold' >Buying a Home</Typography>
              </Grid>
              <Grid item md={12}>
                <Typography variant='subtitle1'>New York County as a whole covers a total area of 33.77 square miles (87.5 km2), ...</Typography>
              </Grid>
              <Grid item md={12}>
                <Typography variant='subtitle1'>published on May 28, 2014</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const Blogs = () => {
  const cards = [
    { title: 'Card 1', content: 'Content 1' },
    { title: 'Card 2', content: 'Content 2' },
    { title: 'Card 3', content: 'Content 3' },
    { title: 'Card 4', content: 'Content 4' },
    { title: 'Card 5', content: 'Content 5' },
  ];

  return (
    <>
        <Grid sx={{padding:'25px 0'}}>
            <Typography variant="h4">Read Our Blogs</Typography>
        </Grid>
        <Grid container spacing={2} justifyContent='space-between'>
        {cards.map((card, index) => (
            <Grid item xs={6} sm={3} md={2.4} key={index}>
            <MyCard title={card.title} content={card.content} />
            </Grid>
        ))}
        </Grid>
    </>
  );
}

export default Blogs;
